/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const dealflowAssigneeDtoSchema = z.object({
  initials: z.optional(z.string()),
  name: z.optional(z.string()),
});
